'use client';

import { getAnonymousId } from '@/utils/rudderstack';

declare global {
  interface Window {
    leia?: {
      leid?: string | undefined;
    };
    leiaFallbackId?: string;
  }
}

export function getLeiaDeviceId() {
  if (!global?.window) return;

  return window?.leia?.leid;
}

// Add whatever values leia needs to send to backend
export function leiaApiPayload() {
  const leid = getLeiaDeviceId();

  if (leid) {
    return {
      leia_device_id: leid,
      le_repo: 'lovevery-next',
    };
  }

  return {
    le_repo: 'lovevery-next',
  };
}

export const generateFallbackLeiaId = () => {
  const randomUUID = crypto.randomUUID();

  return `fb_${randomUUID.replace(/-/g, '')}`;
};

export const getFallbackLeiaId = () => {
  if (typeof window !== 'undefined') {
    if (getAnonymousId()) {
      return getAnonymousId();
    }

    if (window.leiaFallbackId) {
      return window.leiaFallbackId;
    }

    window.leiaFallbackId = generateFallbackLeiaId();

    return window.leiaFallbackId;
  }
};
